import 'react-native-url-polyfill/auto';

/**
 * This file initializes the 'URL' polyfill required for Supabase
 * to work properly with React Native. It should be imported
 * at the entry point of the application.
 *
 * Note: Import this file before any Supabase operations in your
 * application's entry point.
 */

export default function initSupabase() {
  // Supabase initialized
}
